import { createFileRoute, useNavigate, useSearch, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GrnForm } from "@/features/grns/GrnForm";
import { canCreateGrn } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

const search = z.object({ indentId: z.string().optional() });

export const Route = createFileRoute("/_authenticated/grns/new")({
  validateSearch: search,
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateGrn(me.roles)) throw redirect({ to: "/grns" });
  },
  component: NewGrnPage,
});

function NewGrnPage() {
  const navigate = useNavigate();
  const { indentId } = useSearch({ from: "/_authenticated/grns/new" });
  return (
    <div className="mx-auto max-w-4xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/grns" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <GrnForm presetIndentId={indentId} />
    </div>
  );
}
